/** Modulo Perfil (70) — codigos em contracts/enums.yaml */
export const PERFIL_ACAO = {
  CRIAR: 701,
  ATUALIZAR: 702,
  REMOVER: 703,
} as const;

export const PERFIL_ACOES_MODULO = [PERFIL_ACAO.CRIAR, PERFIL_ACAO.ATUALIZAR, PERFIL_ACAO.REMOVER] as const;
